export default function getInitialsLetter(fullName: string): string {
  const words = fullName.trim().split(/\s+/);
  let initials = "";
  for (const word of words) {
    initials += word[0].toUpperCase();
  }
  return initials;
}
